import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";


const useNavi = () => {
    const navigate =useNavigate();
    const location = useLocation();

    const moveTo = (path)=>{
        navigate(path)
    }

    /**
     * Navigate to a list view with updated query parameters.
     * @param {Object} queryParams - Object containing the query parameters to update.
     */
    const moveToList = (queryParams) => {
        // Parse existing query parameters
        const params = new URLSearchParams(location.search);

        // Update query parameters with new values
        Object.entries(queryParams).forEach(([key, value]) => {
            if (value === null || value === undefined) {
                params.delete(key); // Remove parameter if null/undefined
            } else {
                params.set(key, value); // Set or update parameter
            }
        });

        // Navigate with updated query parameters
        navigate({
            pathname: location.pathname,
            search: params.toString(),
        });
    };

    const handleBack = () => {
        navigate(-1); // 브라우저 히스토리에서 이전 페이지로 이동
    };

    return {moveTo,moveToList, handleBack};
}

export default useNavi;
